
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {TransactionType} from '../entity/TransactionType';
import {FieldModelTransactionType} from '../entity/TransactionType';
import {TradeTransactionReason} from '../core/TradeTransactionReason';
import {FieldModelTradeTransactionReason} from '../core/TradeTransactionReason';
import {TradeEvent} from '../entity/TradeEvent';
import {FieldModelTradeEvent} from '../entity/TradeEvent';
import {OrderStatus} from '../core/OrderStatus';
import {FieldModelOrderStatus} from '../core/OrderStatus';
import {AccountMarginUpdate} from './AccountMarginUpdate';
import {FieldModelAccountMarginUpdate} from './AccountMarginUpdate';

/**
 * OrderDeleteRequestParams struct
 */
class OrderDeleteRequestParams {
  /**
   * Initialize struct
   * @param {!number=} orderId
   * @param {!UUID=} accountGroupId
   * @param {!TransactionType=} transactionType
   * @param {!TradeTransactionReason=} transactionReason
   * @param {number=} profitRate
   * @param {number=} balanceChange
   * @param {number=} closeMarginRate
   * @param {string=} externalClientId
   * @param {number=} lastClosePrice
   * @param {number=} lastCloseAmount
   * @param {!Array=} tradeEvents
   * @param {number=} closePrice
   * @param {number=} closeAmount
   * @param {number=} profit
   * @param {number=} closeMarkup
   * @param {string=} managerComment
   * @param {OrderStatus=} orderStatus
   * @param {AccountMarginUpdate=} accountMarginUpdate
   * @param {number=} transactionTradeVolumeUSD
   * @constructor
   */
  constructor (orderId = new UInt64(0, 0), accountGroupId = new UUID(), transactionType = new TransactionType(), transactionReason = new TradeTransactionReason(), profitRate = null, balanceChange = null, closeMarginRate = null, externalClientId = null, lastClosePrice = null, lastCloseAmount = null, tradeEvents = [], closePrice = null, closeAmount = null, profit = null, closeMarkup = null, managerComment = null, orderStatus = null, accountMarginUpdate = null, transactionTradeVolumeUSD = null) {
    this.OrderId = orderId
    this.AccountGroupId = accountGroupId
    this.TransactionType = transactionType
    this.TransactionReason = transactionReason
    this.ProfitRate = profitRate
    this.BalanceChange = balanceChange
    this.CloseMarginRate = closeMarginRate
    this.ExternalClientId = externalClientId
    this.LastClosePrice = lastClosePrice
    this.LastCloseAmount = lastCloseAmount
    this.TradeEvents = tradeEvents
    this.ClosePrice = closePrice
    this.CloseAmount = closeAmount
    this.Profit = profit
    this.CloseMarkup = closeMarkup
    this.ManagerComment = managerComment
    this.OrderStatus = orderStatus
    this.AccountMarginUpdate = accountMarginUpdate
    this.TransactionTradeVolumeUSD = transactionTradeVolumeUSD
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderDeleteRequestParams}
   * @param {!OrderDeleteRequestParams} other Other struct
   * @returns {!OrderDeleteRequestParams} This struct
   */
  copy (other) {
    if (other.OrderId != null) {
      this.OrderId = UInt64.fromNumber(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.AccountGroupId != null) {
      this.AccountGroupId = new UUID(other.AccountGroupId)
    } else {
      this.AccountGroupId = null
    }
    if (other.TransactionType != null) {
      this.TransactionType = TransactionType.fromObject(other.TransactionType)
    } else {
      this.TransactionType = null
    }
    if (other.TransactionReason != null) {
      this.TransactionReason = TradeTransactionReason.fromObject(other.TransactionReason)
    } else {
      this.TransactionReason = null
    }
    if (other.ProfitRate != null) {
      this.ProfitRate = other.ProfitRate
    } else {
      this.ProfitRate = null
    }
    if (other.BalanceChange != null) {
      this.BalanceChange = other.BalanceChange
    } else {
      this.BalanceChange = null
    }
    if (other.CloseMarginRate != null) {
      this.CloseMarginRate = other.CloseMarginRate
    } else {
      this.CloseMarginRate = null
    }
    if (other.ExternalClientId != null) {
      this.ExternalClientId = other.ExternalClientId
    } else {
      this.ExternalClientId = null
    }
    if (other.LastClosePrice != null) {
      this.LastClosePrice = other.LastClosePrice
    } else {
      this.LastClosePrice = null
    }
    if (other.LastCloseAmount != null) {
      this.LastCloseAmount = other.LastCloseAmount
    } else {
      this.LastCloseAmount = null
    }
    if (other.TradeEvents != null) {
      this.TradeEvents = []
      for (let item of other.TradeEvents) {
        if (item != null) {
          let tempItem
          tempItem = TradeEvent.fromObject(item)
          this.TradeEvents.push(tempItem)
        } else {
          this.TradeEvents.push(null)
        }
      }
    } else {
      this.TradeEvents = null
    }
    if (other.ClosePrice != null) {
      this.ClosePrice = other.ClosePrice
    } else {
      this.ClosePrice = null
    }
    if (other.CloseAmount != null) {
      this.CloseAmount = other.CloseAmount
    } else {
      this.CloseAmount = null
    }
    if (other.Profit != null) {
      this.Profit = other.Profit
    } else {
      this.Profit = null
    }
    if (other.CloseMarkup != null) {
      this.CloseMarkup = UInt64.fromNumber(other.CloseMarkup)
    } else {
      this.CloseMarkup = null
    }
    if (other.ManagerComment != null) {
      this.ManagerComment = other.ManagerComment
    } else {
      this.ManagerComment = null
    }
    if (other.OrderStatus != null) {
      this.OrderStatus = OrderStatus.fromObject(other.OrderStatus)
    } else {
      this.OrderStatus = null
    }
    if (other.AccountMarginUpdate != null) {
      this.AccountMarginUpdate = AccountMarginUpdate.fromObject(other.AccountMarginUpdate)
    } else {
      this.AccountMarginUpdate = null
    }
    if (other.TransactionTradeVolumeUSD != null) {
      this.TransactionTradeVolumeUSD = other.TransactionTradeVolumeUSD
    } else {
      this.TransactionTradeVolumeUSD = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderDeleteRequestParams}
   * @returns {!OrderDeleteRequestParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderDeleteRequestParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderDeleteRequestParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderDeleteRequestParams}
   * @param {!OrderDeleteRequestParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderDeleteRequestParams)) {
      throw new TypeError('Instance of OrderDeleteRequestParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderDeleteRequestParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      OrderId: ((this.OrderId != null) ? this.OrderId.toNumber() : null),
      AccountGroupId: ((this.AccountGroupId != null) ? this.AccountGroupId.toString() : null),
      TransactionType: ((this.TransactionType != null) ? this.TransactionType : null),
      TransactionReason: ((this.TransactionReason != null) ? this.TransactionReason : null),
      ProfitRate: ((this.ProfitRate != null) ? this.ProfitRate : null),
      BalanceChange: ((this.BalanceChange != null) ? this.BalanceChange : null),
      CloseMarginRate: ((this.CloseMarginRate != null) ? this.CloseMarginRate : null),
      ExternalClientId: ((this.ExternalClientId != null) ? this.ExternalClientId : null),
      LastClosePrice: ((this.LastClosePrice != null) ? this.LastClosePrice : null),
      LastCloseAmount: ((this.LastCloseAmount != null) ? this.LastCloseAmount : null),
      TradeEvents: ((this.TradeEvents != null) ? Array.from(this.TradeEvents, item => ((item != null) ? item : null)) : null),
      ClosePrice: ((this.ClosePrice != null) ? this.ClosePrice : null),
      CloseAmount: ((this.CloseAmount != null) ? this.CloseAmount : null),
      Profit: ((this.Profit != null) ? this.Profit : null),
      CloseMarkup: ((this.CloseMarkup != null) ? this.CloseMarkup.toNumber() : null),
      ManagerComment: ((this.ManagerComment != null) ? this.ManagerComment : null),
      OrderStatus: ((this.OrderStatus != null) ? this.OrderStatus : null),
      AccountMarginUpdate: ((this.AccountMarginUpdate != null) ? this.AccountMarginUpdate : null),
      TransactionTradeVolumeUSD: ((this.TransactionTradeVolumeUSD != null) ? this.TransactionTradeVolumeUSD : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderDeleteRequestParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderDeleteRequestParams} other Object value
   * @returns {!OrderDeleteRequestParams} Created struct
   */
  static fromObject (other) {
    return new OrderDeleteRequestParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderDeleteRequestParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderDeleteRequestParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderDeleteRequestParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4141
  }
}

export { OrderDeleteRequestParams };

/**
 * Fast Binary Encoding OrderDeleteRequestParams field model
 */
class FieldModelOrderDeleteRequestParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.OrderId = new fbe.FieldModelUInt64(buffer, 4 + 4)
    this.AccountGroupId = new fbe.FieldModelUUID(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.TransactionType = new FieldModelTransactionType(buffer, this.AccountGroupId.fbeOffset + this.AccountGroupId.fbeSize)
    this.TransactionReason = new FieldModelTradeTransactionReason(buffer, this.TransactionType.fbeOffset + this.TransactionType.fbeSize)
    this.ProfitRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize), buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize)
    this.BalanceChange = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ProfitRate.fbeOffset + this.ProfitRate.fbeSize), buffer, this.ProfitRate.fbeOffset + this.ProfitRate.fbeSize)
    this.CloseMarginRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.BalanceChange.fbeOffset + this.BalanceChange.fbeSize), buffer, this.BalanceChange.fbeOffset + this.BalanceChange.fbeSize)
    this.ExternalClientId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.CloseMarginRate.fbeOffset + this.CloseMarginRate.fbeSize), buffer, this.CloseMarginRate.fbeOffset + this.CloseMarginRate.fbeSize)
    this.LastClosePrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize), buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize)
    this.LastCloseAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.LastClosePrice.fbeOffset + this.LastClosePrice.fbeSize), buffer, this.LastClosePrice.fbeOffset + this.LastClosePrice.fbeSize)
    this.TradeEvents = new fbe.FieldModelVector(new FieldModelTradeEvent(buffer, this.LastCloseAmount.fbeOffset + this.LastCloseAmount.fbeSize), buffer, this.LastCloseAmount.fbeOffset + this.LastCloseAmount.fbeSize)
    this.ClosePrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.TradeEvents.fbeOffset + this.TradeEvents.fbeSize), buffer, this.TradeEvents.fbeOffset + this.TradeEvents.fbeSize)
    this.CloseAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ClosePrice.fbeOffset + this.ClosePrice.fbeSize), buffer, this.ClosePrice.fbeOffset + this.ClosePrice.fbeSize)
    this.Profit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.CloseAmount.fbeOffset + this.CloseAmount.fbeSize), buffer, this.CloseAmount.fbeOffset + this.CloseAmount.fbeSize)
    this.CloseMarkup = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.Profit.fbeOffset + this.Profit.fbeSize), buffer, this.Profit.fbeOffset + this.Profit.fbeSize)
    this.ManagerComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.CloseMarkup.fbeOffset + this.CloseMarkup.fbeSize), buffer, this.CloseMarkup.fbeOffset + this.CloseMarkup.fbeSize)
    this.OrderStatus = new fbe.FieldModelOptional(new FieldModelOrderStatus(buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize), buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize)
    this.AccountMarginUpdate = new fbe.FieldModelOptional(new FieldModelAccountMarginUpdate(buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize), buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize)
    this.TransactionTradeVolumeUSD = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.AccountMarginUpdate.fbeOffset + this.AccountMarginUpdate.fbeSize), buffer, this.AccountMarginUpdate.fbeOffset + this.AccountMarginUpdate.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderDeleteRequestParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderDeleteRequestParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.OrderId.fbeSize + this.AccountGroupId.fbeSize + this.TransactionType.fbeSize + this.TransactionReason.fbeSize + this.ProfitRate.fbeSize + this.BalanceChange.fbeSize + this.CloseMarginRate.fbeSize + this.ExternalClientId.fbeSize + this.LastClosePrice.fbeSize + this.LastCloseAmount.fbeSize + this.TradeEvents.fbeSize + this.ClosePrice.fbeSize + this.CloseAmount.fbeSize + this.Profit.fbeSize + this.CloseMarkup.fbeSize + this.ManagerComment.fbeSize + this.OrderStatus.fbeSize + this.AccountMarginUpdate.fbeSize + this.TransactionTradeVolumeUSD.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderDeleteRequestParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.OrderId.fbeExtra + this.AccountGroupId.fbeExtra + this.TransactionType.fbeExtra + this.TransactionReason.fbeExtra + this.ProfitRate.fbeExtra + this.BalanceChange.fbeExtra + this.CloseMarginRate.fbeExtra + this.ExternalClientId.fbeExtra + this.LastClosePrice.fbeExtra + this.LastCloseAmount.fbeExtra + this.TradeEvents.fbeExtra + this.ClosePrice.fbeExtra + this.CloseAmount.fbeExtra + this.Profit.fbeExtra + this.CloseMarkup.fbeExtra + this.ManagerComment.fbeExtra + this.OrderStatus.fbeExtra + this.AccountMarginUpdate.fbeExtra + this.TransactionTradeVolumeUSD.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderDeleteRequestParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderDeleteRequestParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderDeleteRequestParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4141
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionReason.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ProfitRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ProfitRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ProfitRate.fbeSize

    if ((fbeCurrentSize + this.BalanceChange.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.BalanceChange.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceChange.fbeSize

    if ((fbeCurrentSize + this.CloseMarginRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseMarginRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarginRate.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.LastClosePrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastClosePrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastClosePrice.fbeSize

    if ((fbeCurrentSize + this.LastCloseAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastCloseAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastCloseAmount.fbeSize

    if ((fbeCurrentSize + this.TradeEvents.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeEvents.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeEvents.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClosePrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.Profit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Profit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Profit.fbeSize

    if ((fbeCurrentSize + this.CloseMarkup.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseMarkup.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarkup.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderStatus.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.AccountMarginUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountMarginUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMarginUpdate.fbeSize

    if ((fbeCurrentSize + this.TransactionTradeVolumeUSD.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionTradeVolumeUSD.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTradeVolumeUSD.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderDeleteRequestParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {!OrderDeleteRequestParams} fbeValue Default value, defaults is new OrderDeleteRequestParams()
   * @returns {!OrderDeleteRequestParams} OrderDeleteRequestParams value
   */
  get (fbeValue = new OrderDeleteRequestParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {!OrderDeleteRequestParams} fbeValue OrderDeleteRequestParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) <= fbeStructSize) {
      fbeValue.AccountGroupId = this.AccountGroupId.get()
    } else {
      fbeValue.AccountGroupId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionType = this.TransactionType.get()
    } else {
      fbeValue.TransactionType = new TransactionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionReason = this.TransactionReason.get()
    } else {
      fbeValue.TransactionReason = new TradeTransactionReason()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ProfitRate.fbeSize) <= fbeStructSize) {
      fbeValue.ProfitRate = this.ProfitRate.get()
    } else {
      fbeValue.ProfitRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ProfitRate.fbeSize

    if ((fbeCurrentSize + this.BalanceChange.fbeSize) <= fbeStructSize) {
      fbeValue.BalanceChange = this.BalanceChange.get()
    } else {
      fbeValue.BalanceChange = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceChange.fbeSize

    if ((fbeCurrentSize + this.CloseMarginRate.fbeSize) <= fbeStructSize) {
      fbeValue.CloseMarginRate = this.CloseMarginRate.get()
    } else {
      fbeValue.CloseMarginRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarginRate.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientId = this.ExternalClientId.get()
    } else {
      fbeValue.ExternalClientId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.LastClosePrice.fbeSize) <= fbeStructSize) {
      fbeValue.LastClosePrice = this.LastClosePrice.get()
    } else {
      fbeValue.LastClosePrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastClosePrice.fbeSize

    if ((fbeCurrentSize + this.LastCloseAmount.fbeSize) <= fbeStructSize) {
      fbeValue.LastCloseAmount = this.LastCloseAmount.get()
    } else {
      fbeValue.LastCloseAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastCloseAmount.fbeSize

    if ((fbeCurrentSize + this.TradeEvents.fbeSize) <= fbeStructSize) {
      this.TradeEvents.get(fbeValue.TradeEvents)
    } else {
      fbeValue.TradeEvents.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeEvents.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) <= fbeStructSize) {
      fbeValue.ClosePrice = this.ClosePrice.get()
    } else {
      fbeValue.ClosePrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) <= fbeStructSize) {
      fbeValue.CloseAmount = this.CloseAmount.get()
    } else {
      fbeValue.CloseAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.Profit.fbeSize) <= fbeStructSize) {
      fbeValue.Profit = this.Profit.get()
    } else {
      fbeValue.Profit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Profit.fbeSize

    if ((fbeCurrentSize + this.CloseMarkup.fbeSize) <= fbeStructSize) {
      fbeValue.CloseMarkup = this.CloseMarkup.get()
    } else {
      fbeValue.CloseMarkup = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarkup.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerComment = this.ManagerComment.get()
    } else {
      fbeValue.ManagerComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) <= fbeStructSize) {
      fbeValue.OrderStatus = this.OrderStatus.get()
    } else {
      fbeValue.OrderStatus = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.AccountMarginUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.AccountMarginUpdate = this.AccountMarginUpdate.get()
    } else {
      fbeValue.AccountMarginUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMarginUpdate.fbeSize

    if ((fbeCurrentSize + this.TransactionTradeVolumeUSD.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionTradeVolumeUSD = this.TransactionTradeVolumeUSD.get()
    } else {
      fbeValue.TransactionTradeVolumeUSD = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTradeVolumeUSD.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderDeleteRequestParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {!OrderDeleteRequestParams} fbeValue OrderDeleteRequestParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderDeleteRequestParams}
   * @param {OrderDeleteRequestParams} fbeValue OrderDeleteRequestParams value
   */
  setFields (fbeValue) {
    this.OrderId.set(fbeValue.OrderId)
    this.AccountGroupId.set(fbeValue.AccountGroupId)
    this.TransactionType.set(fbeValue.TransactionType)
    this.TransactionReason.set(fbeValue.TransactionReason)
    this.ProfitRate.set(fbeValue.ProfitRate)
    this.BalanceChange.set(fbeValue.BalanceChange)
    this.CloseMarginRate.set(fbeValue.CloseMarginRate)
    this.ExternalClientId.set(fbeValue.ExternalClientId)
    this.LastClosePrice.set(fbeValue.LastClosePrice)
    this.LastCloseAmount.set(fbeValue.LastCloseAmount)
    this.TradeEvents.set(fbeValue.TradeEvents)
    this.ClosePrice.set(fbeValue.ClosePrice)
    this.CloseAmount.set(fbeValue.CloseAmount)
    this.Profit.set(fbeValue.Profit)
    this.CloseMarkup.set(fbeValue.CloseMarkup)
    this.ManagerComment.set(fbeValue.ManagerComment)
    this.OrderStatus.set(fbeValue.OrderStatus)
    this.AccountMarginUpdate.set(fbeValue.AccountMarginUpdate)
    this.TransactionTradeVolumeUSD.set(fbeValue.TransactionTradeVolumeUSD)
  }
}

export { FieldModelOrderDeleteRequestParams };

/**
 * Fast Binary Encoding OrderDeleteRequestParams model
 */
class OrderDeleteRequestParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderDeleteRequestParams(this.buffer, 4)
  }

  /**
   * Get the OrderDeleteRequestParams model
   * @this {!OrderDeleteRequestParamsModel}
   * @returns {!FieldModelOrderDeleteRequestParams} model OrderDeleteRequestParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderDeleteRequestParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderDeleteRequestParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderDeleteRequestParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderDeleteRequestParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderDeleteRequestParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderDeleteRequestParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderDeleteRequestParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderDeleteRequestParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderDeleteRequestParamsModel}
   * @param {!OrderDeleteRequestParams} value OrderDeleteRequestParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderDeleteRequestParamsModel}
   * @param {!OrderDeleteRequestParams} value OrderDeleteRequestParams value, defaults is new OrderDeleteRequestParams()
   * @return {!object} Deserialized OrderDeleteRequestParams value and its size
   */
  deserialize (value = new OrderDeleteRequestParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderDeleteRequestParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderDeleteRequestParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderDeleteRequestParamsModel}
   * @param {!number} prev Previous OrderDeleteRequestParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderDeleteRequestParamsModel };
